/* eslint-disable */
import { get } from 'lodash';
import store from '@/store';
import { UX_CATEGORY } from '@/store/modules/app';

/*
  When new version is introduced to migrate to (e.g)
  change VERSION_TO_MIGRATE_TO to 2 and update what-is-new-popup and what-is-new-popup-footer
   to use different flow for instance whatIsNewFlowVersion2
*/

export const VERSION_SETTINGS_LOADING = -1;
export const VERSION_TO_MIGRATE_TO = 1;

export const getCurrentVersionNumber = () => {
  const version = get(
    store.state.profile.settings.ux,
    UX_CATEGORY.UXSettingAnnouncementCurState,
    VERSION_SETTINGS_LOADING.toString(),
  );
  return parseInt(version, 10);
};

export const shouldShowWhatsIsNewPopup = () => {
  const versionNumber = getCurrentVersionNumber();
  return (
    !!store.getters['user/isLoggedIn'] &&
    versionNumber !== VERSION_SETTINGS_LOADING &&
    versionNumber < VERSION_TO_MIGRATE_TO
  );
};
